import { useState, useEffect } from "react";
import { db } from "../../firebase";
import { collection, getDocs, deleteDoc, doc } from "firebase/firestore";
import AddAction from "./AddAction";

const ActionList = () => {
  const [actions, setActions] = useState([]);
  const [formMode, setFormMode] = useState(false);
  const [editAction, setEditAction] = useState(null);

  const fetchActions = async () => {
    const snapshot = await getDocs(collection(db, "actions"));
    const list = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
    setActions(list);
  };

  const handleDelete = async (id) => {
    const confirmed = window.confirm("Видалити акцію?");
    if (confirmed) {
      await deleteDoc(doc(db, "actions", id));
      fetchActions();
    }
  };

  useEffect(() => {
    fetchActions();
  }, []);

  return (
    <div style={{ padding: 20 }}>
      <h2>Усі акції</h2>
      <button
        onClick={() => {
          setFormMode(true);
          setEditAction(null);
        }}
        style={{ marginBottom: 20 }}
      >
        Додати акцію
      </button>

      <table border="1" cellPadding="8">
        <thead>
          <tr>
            <th>Назва</th>
            <th>Знижка</th>
            <th>Серії</th>
            <th>Товари</th>
            <th>Автори</th>
            <th>Період</th>
            <th>Дії</th>
          </tr>
        </thead>
        <tbody>
          {actions.map((a) => (
            <tr key={a.id}>
              <td>{a.title}</td>
              <td>{a.discountPercent}%</td>
              <td>{a.appliesTo.series?.join(", ") || "-"}</td>
              <td>{a.appliesTo.products?.length || "-"}</td>
              <td>{a.appliesTo.authors?.join(", ") || "-"}</td>
              <td>
                {a.startDate ? a.startDate.split("T")[0] : "—"} до{" "}
                {a.endDate ? a.endDate.split("T")[0] : "—"}
              </td>
              <td>
                <button
                  onClick={() => {
                    setFormMode(true);
                    setEditAction(a);
                  }}
                >
                  Редагувати
                </button>
                <button onClick={() => handleDelete(a.id)}>Видалити</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {formMode && (
        <AddAction
          onClose={() => {
            setFormMode(false);
            fetchActions();
          }}
          editAction={editAction}
        />
      )}
    </div>
  );
};

export default ActionList;
